import { render, staticRenderFns } from "./ClaimAccount.vue?vue&type=template&id=7a7d2a71&scoped=true"
import script from "./ClaimAccount.vue?vue&type=script&lang=ts"
export * from "./ClaimAccount.vue?vue&type=script&lang=ts"
import style0 from "./ClaimAccount.vue?vue&type=style&index=0&id=7a7d2a71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7d2a71",
  null
  
)

export default component.exports